import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EmpNoteComponent } from './emp-note.component';
import { EmployeeService } from '@app/cp/shared/services/employee.service';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
@NgModule({
    imports: [
        CommonModule,
        DropDownsModule,
        DialogModule,
        FormsModule,
        EditorModule,
        InputsModule,
        MatExpansionModule,
        ReactiveFormsModule,
        LayoutModule,
        ButtonsModule
    ],
    declarations: [
        EmpNoteComponent
    ],
    exports: [
        EmpNoteComponent
    ],
     providers: [GlobalsService, EmployeeService]

})
export class EmpNoteModule { }

